import React, { Component } from "react";
import "../../App.scss";
// import TabBar from "./tabBar";
import AdminDB from "./administrator";
import CaretakerDB from "./caretaker";
import CashierDB from "./cashier";
import CopywriterDB from "./copywriter";
import SalesPersonDB from "./salesperson";
import InspectorDB from "./inspector";
import SalesDB from "./adminSalesDashboard";
import "./dashboard.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import BlockUser from "../../components/blockUser/blockUser";

const userRole = {
  admin :"Admin",
  cashier :"Cashier",
  careTaker :"Caretaker",
  copyWriter:"Copywriter",
  salesPerson:"SalesPerson",
  inspector:"Inspector",
};

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null
    };
  }

  getToken() {
    let username = this.props.user.username;
    let clientId = this.props.user.pool.clientId;
    let token = this.props.user.storage[
      "CognitoIdentityServiceProvider." +
        clientId +
        "." +
        username +
        ".accessToken"
    ];
    return token;
  }

  componentWillReceiveProps(nextProps) {}
  componentDidMount() {
    this.getToken();
    this.setState({ user: this.props.user });
  }
  render() {
    const { currentUser } = this.props;
    return (
      <div>
        {/* <TabBar /> */}
        {/* {currentUser &&
        currentUser.UserPetstores[0].Role.role_name !== "Admin" ? (
          <BlockUser />
        ) : null} */}

        {currentUser &&
        currentUser.UserPetstores[0].Role.role_name === "Admin" ? (
          <SalesDB />
        ) : currentUser &&
          currentUser.UserPetstores[0].Role.role_name === "Caretaker" ? (
          <CaretakerDB />
        ) : currentUser &&
          currentUser.UserPetstores[0].Role.role_name === "Cashier" ? (
          <CashierDB />
        ) : currentUser &&
        currentUser.UserPetstores[0].Role.role_name === "Copywriter" ? (
        <CopywriterDB />
        ) : currentUser &&
         currentUser.UserPetstores[0].Role.role_name === userRole.salesPerson ? (
        <SalesPersonDB />
      ) : currentUser &&
         currentUser.UserPetstores[0].Role.role_name === userRole.inspector ? (
        <InspectorDB/>)
        : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  currentUser: state.userReducer.currentUser
});
const mapDispatchToProps = dispatch => ({});
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Dashboard)
);
